import { Rhythm, Text } from '@trmediaab/zebra';
import { useCallback, useEffect } from 'react';

import InfoCard from '../../components/Card/InfoCard';
import { SelectInput } from '../../components/Form';
import type { CheckoutState } from '../../state';
import { setCountry } from '../../state';
import { useCountryOptions } from '../../utils/useCountryOptions';

interface ChooseCountryProps {
  defaultCountry: string;
  order: NonNullable<CheckoutState['order']>;
  disabled: boolean;
  onChange: (country: string) => void;
}

const ChooseCountry = ({
  defaultCountry,
  order,
  disabled,
  onChange,
}: ChooseCountryProps) => {
  const countries = useCountryOptions();

  const onCountryChange = useCallback(
    (country: string) => {
      onChange(country);
      setCountry(country);
    },
    [onChange],
  );

  useEffect(() => {
    if (!order.address?.country) {
      onCountryChange(defaultCountry);
    }
  }, [defaultCountry, onCountryChange, order.address?.country]);

  return (
    <InfoCard
      title="Det ser ut som att du inte befinner dig i Sverige"
      body={
        <Rhythm between="4">
          <Text>
            Av momsrättsliga skäl behöver du ange bostadsland där tjänsten
            varaktigt avses konsumeras.
          </Text>
          <SelectInput
            name="country"
            value={order.address?.country || defaultCountry}
            data={[{ value: '', label: 'Välj land' }, ...countries]}
            disabled={disabled}
            width="100%"
            onChange={e => onCountryChange(e.target.value)}
          />
        </Rhythm>
      }
    />
  );
};

export default ChooseCountry;
